var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 0.25H2.125C1.08984 0.25 0.25 1.08984 0.25 2.125V15.875C0.25 16.9102 1.08984 17.75 2.125 17.75H15.875C16.9102 17.75 17.75 16.9102 17.75 15.875V2.125C17.75 1.08984 16.9102 0.25 15.875 0.25ZM13.9648 6.45312C13.9727 6.5625 13.9727 6.67578 13.9727 6.78516C13.9727 10.1719 11.3945 14.0742 6.68359 14.0742C5.23047 14.0742 3.88281 13.6523 2.75 12.9258C2.95703 12.9492 3.15625 12.957 3.36719 12.957C4.56641 12.957 5.66797 12.5508 6.54688 11.8633C5.42188 11.8398 4.47656 11.1016 4.15234 10.0859C4.54688 10.1445 4.90234 10.1445 5.30859 10.0391C4.13672 9.80078 3.25781 8.76953 3.25781 7.52344V7.49219C3.59766 7.68359 3.99609 7.80078 4.41406 7.81641C4.06267 7.58267 3.7746 7.26557 3.57557 6.89342C3.37655 6.52127 3.27275 6.10563 3.27344 5.68359C3.27344 5.20703 3.39844 4.76953 3.62109 4.39062C4.88281 5.94531 6.77734 6.96094 8.90234 7.07031C8.53906 5.33203 9.83984 3.92188 11.4023 3.92188C12.1406 3.92188 12.8047 4.23047 13.2734 4.73047C13.8516 4.62109 14.4062 4.40625 14.8984 4.11328C14.707 4.70703 14.3047 5.20703 13.7734 5.52344C14.2891 5.46875 14.7891 5.32422 15.25 5.125C14.9023 5.63672 14.4648 6.08984 13.9648 6.45312Z",
    fill: "#292830"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.6bcf67328c01dd5ba4aab0e76150cfba.svg";
export { ForwardRef as ReactComponent };